import {
  RESET,
  SET_IS_FETCHING_STATUSES,
  SET_SELECTED_STATUSES,
  SET_STATUSES,
} from "./statusFilter.actionTypes";

const initialState = {
  isFetchingStatuses: false,
  statuses: [],
  selectedStatuses: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STATUSES: {
      return { ...state, statuses: action.payload };
    }

    case SET_SELECTED_STATUSES: {
      return { ...state, selectedStatuses: action.payload };
    }

    case SET_IS_FETCHING_STATUSES: {
      return { ...state, isFetchingStatuses: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
